import React, { useEffect, useState } from "react";
import { BookOpen, Layers } from "lucide-react";
import { getMySubjects } from "../api/teachersubjects/teacherSubjectPortalApi";

import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Badge,
  Skeleton,
  EmptyState,
  PageHeader,
} from "../components/ui";

export default function TeacherSubjectPortal() {
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMySubjects = async () => {
      try {
        const res = await getMySubjects();
        const list = Array.isArray(res) ? res : res.data || res.assignments || [];
        setAssignments(list);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchMySubjects();
  }, []);

  return (
    <div className="mx-auto max-w-7xl space-y-6 p-4 sm:p-6 antialiased">
      <PageHeader
        title="My Assigned Subjects"
        description="Classes and subjects assigned to you for teaching"
      />

      {loading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {Array.from({ length: 6 }).map((_, i) => (
            <Card key={i} className="p-6 space-y-4">
              <Skeleton height={24} width="60%" />
              <Skeleton height={40} width="100%" className="rounded-xl" />
            </Card>
          ))}
        </div>
      ) : assignments.length === 0 ? (
        <Card className="p-8">
          <EmptyState
            icon={BookOpen}
            title="No subjects assigned yet"
            description="You do not have any active subject assignments."
          />
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {assignments.map((item) => (
            <Card
              key={item._id}
              className="transition hover:shadow-md border-t-4"
              style={{
                borderTopColor: item.subjectId?.color || "#3B82F6",
              }}
            >
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-lg font-bold text-neutral-900 dark:text-neutral-100">
                  {item.subjectId?.name}
                </CardTitle>
                {item.subjectId?.code && (
                  <Badge variant="neutral" className="uppercase font-semibold">
                    {item.subjectId.code}
                  </Badge>
                )}
              </CardHeader>
              <CardContent>
                <div className="flex items-center gap-2.5 text-sm text-neutral-600 dark:text-neutral-300 bg-neutral-50 dark:bg-neutral-950 p-3.5 rounded-xl border border-neutral-100 dark:border-neutral-800">
                  <Layers className="h-4 w-4 text-neutral-400 dark:text-neutral-500 shrink-0" />
                  <span>
                    Class: <strong className="text-neutral-900 dark:text-neutral-100 font-semibold">{item.classId?.className}</strong> — Section:{" "}
                    <strong className="text-neutral-900 dark:text-neutral-100 font-semibold">{item.sectionId?.sectionName}</strong>
                  </span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}